import axios from "axios";

import { getQueryString } from "../resources/utils";

const { REACT_APP_API_URL } = process.env;
// Api Call for get chart data

export function getMarketData(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}market-data?${queryString}`;
  return axios.get(apiUrl);
}
export function getDynamicPriceIndex(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}pmdpi?${queryString}`;
  return axios.get(apiUrl);
}
export function getMarketDataRecords(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}market-data-records?${queryString}`;
  return axios.get(apiUrl);
}
// store media for graph for report
export function postHighChartsMedia(data) {
  const apiUrl = `${REACT_APP_API_URL}highcharts-media`;
  return axios.post(apiUrl, data);
}
